import removeAccents from 'remove-accents';

/**
 * Removes all non-alpha-numeric chars
 * using ~`!@#$%^&*()_-+={[}]|\:;'",<.>/?
 * @param str
 */
export const removeSpecialChars = (str: string): string => {
  return removeAccents(str).replace(/[^\dA-Za-z\s]/g, '');
};

/**
 * Generates a numeric hash from a given string for deduplication purposes.
 *
 * @param str - The input string to be hashed.
 * @returns A 32-bit integer hash derived from the input string.
 *
 * @remarks
 * This function computes a hash by iterating through each character of the string,
 * applying bitwise operations to generate a deterministic numeric value.
 * The result is a signed 32-bit integer.
 */
export const hashStringToNumber = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

export const hashStringToNegativeNumber = (str: string): number =>
  -Math.abs(hashStringToNumber(str));

export const isEmailValid = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const normalizeWebhookUrl = (url: string) => {
  if (!url) return null;

  // Only HTTP and HTTPS are supported for webhooks
  const validWebhookSchemes = ['http:', 'https:'];

  let urlToValidate = url;

  // Check if URL already has a valid webhook scheme
  const hasValidScheme = validWebhookSchemes.some((scheme) =>
    url.startsWith(scheme)
  );

  // If no valid scheme found, default to https://
  if (!hasValidScheme) {
    urlToValidate = `https://${url}`; // Default to HTTPS for security
  }

  try {
    const parsedUrl = new URL(urlToValidate);

    return parsedUrl.toString();
  } catch {
    return null;
  }
};
